var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"s-header",class:{ ..._vm.className }},[_c('s-visual',{attrs:{"content":_vm.$props}}),_vm._v(" "),_c('s-content',{attrs:{"content":_vm.$props}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }